import React, {
  Component,
  useCallback,
  useState,
  useContext,
  useEffect
} from 'react';
import {
  HeaderTag,
  Icon,
  T2,
  T3,
  SelectionSheet,
  getParsedCrudData,
  DisabledTag,
  B1,
  BackgroundIcon,
  getTranslatedText,
  toast,
  AccessControl,
  AppContext,
  isAuthorised,
  CURRENCY_SYMBOL_MAP,
  IndicatorSeparator,
  DropdownIndicator,
  Suffix
} from '@nile/components';
import {
  reactSelectErrorStyles,
  reactSelectInlineError,
  BadgeWrapper
} from '@nile/banyan/src/Utils/style';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { AccountClient, GET_SERVICE_ITEMS } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { cloneDeep, pick, omit } from 'lodash';
import dayjs from 'dayjs';
import { useQuery } from '@apollo/client';
import ServiceSheet from '@nile/client_management/src/Pages/ContractTemplate/ServiceSheet';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select';

import { SVGIcon } from '@superops/super-icons';
import { Dropdown, TextField, TextStyle } from '@superops/ui-design-system';
import {
  SCHEDULE_OPTIONS,
  WEEK_OPTIONS,
  DAY_OPTIONS,
  MONTH_DAY_OPTIONS,
  HOUR_OPTIONS,
  MEREDIAN_OPTIONS,
  END_OPTION,
  SCHEDULE_ENDTYPE
} from './constants';

function NewScheduleDurationSection(props) {
  const {
    intl,
    duration,
    filteredOptions,
    allowTime,
    scheduleMessage,
    disableInterval,
    errors,
    showOccurance = false,
    showInterval = false,
    occurancei18nMap,
    readOnly = false,
    hideStartEndDatetime,
    showTimePicker,
    noPadding,
    disablePastDateAndTime,
    maxLimits = {},
    isDisabled
  } = props;
  const [time, setTime] = useState(null);
  const disablePastProps = disablePastDateAndTime
    ? {
        filterTime: (val) => {
          const currentDate = new Date();
          const selectedDate = new Date(val);

          return currentDate.getTime() < selectedDate.getTime();
        },
        // filterDate: (date) => {
        //   const currentDate = new Date();
        //   const selectedDate = new Date(date);

        //   return (
        //     currentDate.toLocaleDateString() <=
        //     selectedDate.toLocaleDateString()
        //   );
        //   // return currentDate.getTime() < selectedDate.getTime();
        // },
        minDate: dayjs(new Date()).toDate()
      }
    : {};
  const { frequency, data } = duration;
  useEffect(() => {
    if (data?.time) {
      const updatedTime = new Date();
      const [hrs, mins] = data?.time.split(':');
      updatedTime.setHours(hrs);
      updatedTime.setMinutes(mins);
      setTime(updatedTime || null);
    }
  }, [data?.time]);

  const FILTERED_SCHEDULE_OPTIONS = filteredOptions
    ? SCHEDULE_OPTIONS.filter((opt) => filteredOptions.includes(opt.value))
    : SCHEDULE_OPTIONS;

  const handleDurationChange = (field, value) => {
    let updatedDuration = cloneDeep(duration);
    const objToUpdate = {};
    const val = {};
    let updatedTime = '';
    let timeValue = '';
    switch (field) {
      case 'frequency':
        if (frequency !== value.value) {
          updatedDuration = {
            frequency: value.value,
            data: {
              repeatInterval: '1' || updatedDuration.data.repeatInterval,
              endType: updatedDuration.data.endType,
              time: updatedDuration.data.time,
              ...(updatedDuration.data.endDate ||
              updatedDuration.data.endDateAndTime
                ? allowTime
                  ? { endDateAndTime: updatedDuration.data?.endDateAndTime }
                  : { endDate: updatedDuration.data?.endDate }
                : {}),
              ...(updatedDuration.data?.startDate ||
              updatedDuration.data?.startDateAndTime
                ? allowTime
                  ? { startDateAndTime: updatedDuration.data?.startDateAndTime }
                  : { startDate: updatedDuration.data?.startDate }
                : {})
            }
          };
        }
        break;
      case 'repeatInterval':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            repeatInterval: value
          }
        };
        break;
      case 'endType':
        updatedDuration =
          value.value === 'never'
            ? {
                ...updatedDuration,
                data: {
                  ...updatedDuration.data,
                  endType: value.value,
                  endDate: null,
                  endDateAndTime: null,
                  repeatCount: null
                }
              }
            : {
                ...updatedDuration,
                data: {
                  ...updatedDuration.data,
                  endType: value.value
                }
              };
        break;
      case 'repeatCount':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            startDate: null,
            repeatCount: value
          }
        };
        break;
      case 'time':
        function padTo2Digits(num) {
          return String(num).padStart(2, '0');
        }

        const date = value;
        const hoursAndMinutes = `${padTo2Digits(
          date.getHours()
        )}:${padTo2Digits(date.getMinutes())}`;

        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            time: hoursAndMinutes
          }
        };
        break;
      case 'meridian':
        timeValue = Number(updatedDuration.data?.time.split(':')[0]);
        updatedTime =
          value.value === 'AM'
            ? timeValue > 12
              ? `${timeValue - 12}:${updatedDuration.data?.time.split(':')[1]}`
              : updatedDuration.data?.time
            : timeValue < 12
            ? `${timeValue + 12}:${updatedDuration.data?.time.split(':')[1]}`
            : updatedDuration.data?.time;
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            time: updatedTime
          }
        };
        break;
      case 'type':
        objToUpdate.type = value.type;
        if (value.type === 'DAY_OF_MONTH') {
          objToUpdate.dayOfMonth = value.value;
        }
        if (value.type === 'WEEK_OF_MONTH') {
          objToUpdate.week = value.value;
        }
        updatedDuration = {
          ...updatedDuration,
          data: {
            // time: updatedDuration.data?.time,
            // startDate: updatedDuration.data?.startDate,
            ...updatedDuration.data,
            ...objToUpdate
          }
        };
        break;
      case 'day':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            dayOfWeek: value.value
          }
        };
        break;
      case 'date':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            startDate: dayjs(value).format('YYYY-MM-DD')
          }
        };
        break;
      case 'endDate':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            endDate: dayjs(value).format('YYYY-MM-DD')
          }
        };
        break;
      case 'startDateAndTime':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            startDateAndTime: dayjs(value).format('YYYY-MM-DDTHH:mm:ss'),
            startDate: null,
            repeatCount: null
          }
        };
        break;
      case 'endDateAndTime':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            endDateAndTime: dayjs(value).format('YYYY-MM-DDTHH:mm:ss'),
            endDate: null,
            repeatCount: null
          }
        };
        break;

      case 'noOfTimes':
        updatedDuration = {
          ...updatedDuration,
          data: {
            ...updatedDuration.data,
            noOfTimes: value,
            endDate: null,
            endDateAndTime: null
          }
        };
        break;
      default:
        break;
    }
    props.updateParent(updatedDuration);
  };
  // const timeValue = data.time ? Number(data.time.split(':')[0]) : '';
  // const displayTime =
  //   timeValue > 12 ? `${timeValue - 12}:${data.time.split(':')[1]}` : data.time;

  const weekOptions = WEEK_OPTIONS.map((el) => ({
    ...el,
    label: el.value === 'LAST' ? getTranslatedText(intl, el.label) : el.label
  }));

  const monthDayOptions = MONTH_DAY_OPTIONS.map((el) => ({
    ...el,
    label: el.value === '0' ? getTranslatedText(intl, el.label) : el.label
  }));

  const dayOptions = DAY_OPTIONS.map((el) => {
    return {
      ...el,
      label: getTranslatedText(intl, el.label)
    };
  });

  const groupedOptions = [
    {
      label: 'Week options',
      options: weekOptions
    },
    {
      label: 'Day options',
      options: monthDayOptions
    }
  ];
  const selectedTypeOfDuration =
    data?.type === 'DAY_OF_MONTH'
      ? MONTH_DAY_OPTIONS.map((el) => ({
          ...el,
          label: el.value === '0' ? getTranslatedText(intl, el.label) : el.label
        })).find((el) => el.value === data?.dayOfMonth)
      : WEEK_OPTIONS.map((el) => ({
          ...el,
          label:
            el.value === 'LAST' ? getTranslatedText(intl, el.label) : el.label
        })).find((el) => el.value === data?.week);
  let selectedDay = DAY_OPTIONS.find((el) => el.value === data?.dayOfWeek);
  selectedDay = selectedDay
    ? {
        ...selectedDay,
        label: getTranslatedText(intl, selectedDay.label)
      }
    : null;

  const dayOption = MONTH_DAY_OPTIONS.map((el) => ({
    ...el,
    label: el.value === '0' ? getTranslatedText(intl, el.label) : el.label
  }));

  const endOption = END_OPTION.map((option) => ({
    ...option,
    label: getTranslatedText(intl, option.label)
  }));

  const filteredScheduleOptions = FILTERED_SCHEDULE_OPTIONS.map((el) => ({
    ...el,
    label: getTranslatedText(intl, el.label)
  }));
  let currentScheduleFrequency = filteredScheduleOptions.find(
    (el) => el.value === frequency
  );
  // if (!currentScheduleFrequency) {
  //   currentScheduleFrequency = filteredScheduleOptions[1];
  // }
  return (
    <Wrapper
      className={isDisabled ? 'pointer-events-none schedule-disabled' : ''}
    >
      <div className={`flex center relative ${!noPadding && 'mb-20'}`}>
        <ScheduleMessageContainer
          className="mr-10"
          clickable={props?.onScheduleMessageClick}
          onClick={props?.onScheduleMessageClick}
        >
          <FormattedMessage id={scheduleMessage || 'schedule.info.message'} />
        </ScheduleMessageContainer>
        <div className="mr-10 flex actr">
          <SVGIcon name="Frequency" size="sm" />
        </div>

        <div className="numberInput">
          <TextField
            value={data?.repeatInterval?.toString()}
            onChange={(value) => handleDurationChange('repeatInterval', value)}
            customClassName="w50 text-input"
            type="number"
            min={1}
            max={maxLimits[frequency]}
            onBlur={(e) => {
              if (Number(e.target.value) < 1)
                handleDurationChange('repeatInterval', '1');
              if (Number(e.target.value) > maxLimits[frequency])
                handleDurationChange('repeatInterval', maxLimits[frequency]);
            }}
            placeholder={
              '1' || getTranslatedText(intl, 'schedule.interval.placeholder')
            }
            disabled={disableInterval || readOnly}
            error={errors?.repeatInterval}
            suffix={
              <Select
                className="w100p unit-selector"
                classNamePrefix="value_selector"
                value={currentScheduleFrequency}
                components={{ IndicatorSeparator, DropdownIndicator }}
                onChange={(value) => handleDurationChange('frequency', value)}
                options={filteredScheduleOptions}
                placeholder="select"
                menuPortalTarget={document.body}
                menuPlacement="auto"
                isSearchable={false}
                isDisabled={readOnly}
                closeMenuOnScroll={(e) => {
                  return (
                    e.target &&
                    e.target.classList &&
                    !(e.target.classList.value.indexOf('menu-list') > -1)
                  );
                }}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, width: 50 })
                }}
              />
            }
          />
        </div>
        <div className="ml-10 mr-10">
          {frequency === 'HOURLY' || frequency === 'DAILY' ? (
            <FormattedMessage id="schedule.info.message.once" />
          ) : showOccurance ? (
            <FormattedMessage id={occurancei18nMap.conjunctionText} />
          ) : (
            <FormattedMessage id="schedule.info.message.onceon" />
          )}
        </div>
        {showOccurance && (frequency === 'MINUTES' || frequency === 'HOURLY') && (
          <div className="fx center">
            <div className="fx actr">
              <TextField
                value={data?.noOfTimes?.toString()}
                onChange={(value) => handleDurationChange('noOfTimes', value)}
                customClassName="w120 occurance-input"
                type="number"
                placeholder={getTranslatedText(
                  intl,
                  occurancei18nMap.placeholder
                )}
                disabled={readOnly}
                error={errors?.noOfTimes}
              />
              <BadgeWrapper marginLeft="-50px" marginTop="5px">
                <FormattedMessage id="schedule.occurance.badge" />
              </BadgeWrapper>
            </div>
            <div className="ml-10">
              <FormattedMessage id={occurancei18nMap.helpText} />
            </div>
          </div>
        )}

        {frequency === 'MONTHLY' && (
          <div className="flex">
            <div className="mr-10 flex actr">
              <SVGIcon name="DateTime" size="md" />
            </div>
            <Select
              className=""
              classNamePrefix="value_selector"
              value={selectedTypeOfDuration}
              components={{ IndicatorSeparator, DropdownIndicator }}
              onChange={(value) => handleDurationChange('type', value)}
              options={groupedOptions}
              placeholder={getTranslatedText(
                intl,
                'schedule.duration.options.placeholder'
              )}
              isDisabled={readOnly}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              styles={
                errors?.type
                  ? {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({ ...base, width: 50 }),
                      ...reactSelectErrorStyles
                    }
                  : {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({ ...base, width: 50 })
                    }
              }
            />
          </div>
        )}
        {(data?.type === 'WEEK_OF_MONTH' || frequency === 'WEEKLY') && (
          <div className="flex">
            <Select
              className="ml-10"
              classNamePrefix="value_selector"
              value={selectedDay}
              isDisabled={readOnly}
              components={{ IndicatorSeparator, DropdownIndicator }}
              onChange={(value) => handleDurationChange('day', value)}
              options={dayOptions}
              placeholder={getTranslatedText(
                intl,
                'invoiceSettings.weekOfMonth.duration.placeholder'
              )}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              styles={
                errors?.dayOfWeek
                  ? {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({ ...base, width: 50 }),
                      ...reactSelectErrorStyles
                    }
                  : {
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({ ...base, width: 50 })
                    }
              }
            />
          </div>
        )}
        {/* <Select
            className=""
            classNamePrefix="value_selector"
            value={HOUR_OPTIONS.find((el) => el.value === displayTime)}
            components={{ IndicatorSeparator, DropdownIndicator }}
            onChange={(value) => handleDurationChange('time', value)}
            options={HOUR_OPTIONS}
            placeholder="0"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({ ...base, width: 50 })
            }}
          />
          <Select
            className=""
            classNamePrefix="value_selector"
            value={
              timeValue >= 12
                ? { label: 'PM', value: 'PM' }
                : { label: 'AM', value: 'AM' }
            }
            components={{ IndicatorSeparator, DropdownIndicator }}
            onChange={(value) => handleDurationChange('meridian', value)}
            options={MEREDIAN_OPTIONS}
            placeholder="0"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({ ...base, width: 50 })
            }}
          /> */}
        {showTimePicker && (
          <div className="ml-10 schedule-time-picker flex">
            <div className="mr-10 flex actr">
              <SVGIcon name="EstimatedTime" size="md" />
            </div>
            <DatePicker
              selected={time}
              onChange={(value) => handleDurationChange('time', value)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="hh:mm aa"
              placeholderText={getTranslatedText(
                intl,
                'asset.runscript.script.time.placeholder'
              )}
            />
          </div>
        )}
      </div>
      {!hideStartEndDatetime && (
        <div className="flex center">
          {!!frequency && !showOccurance && (
            <div className="datepicker-wrapper flex">
              <div className="mr-10">
                <FormattedMessage id="client.details.contract.scheduleStartingFrom" />
              </div>
              <div className="mr-10" style={{ opacity: '0.8' }}>
                <SVGIcon name="DatePicker" />
              </div>
              <DatePicker
                selected={
                  allowTime
                    ? data.startDateAndTime &&
                      dayjs(data.startDateAndTime).toDate()
                    : data.startDate && dayjs(data.startDate).toDate()
                }
                onChange={(value) =>
                  allowTime
                    ? handleDurationChange('startDateAndTime', value)
                    : handleDurationChange('date', value)
                }
                {...disablePastProps}
                onKeyDown={(e) => e.preventDefault()}
                placeholderText={allowTime ? 'YYYY-MM-DD, HH:MM' : 'YYYY-MM-DD'}
                dateFormat={allowTime ? 'yyyy-MM-dd, h:mm aa' : 'yyyy-MM-dd'}
                required
                disabled={readOnly}
                showTimeSelect={allowTime}
                timeIntervals={15}
                popperPlacement="auto"
              />
            </div>
          )}
          {showInterval && (
            <div className="flex actr">
              <div className="mr-10">
                <TextStyle>Ends</TextStyle>
              </div>
              <div className="mr-10 flex actr">
                <SVGIcon name="Clock" size="sm" />
              </div>
              <Select
                className="w100p"
                classNamePrefix="value_selector"
                value={endOption.find((el) => el.value === data.endType)}
                onChange={(selectedIndex) =>
                  handleDurationChange('endType', selectedIndex)
                }
                name="valueselector"
                components={{ IndicatorSeparator, DropdownIndicator }}
                // styles={{
                //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                //   menu: (base) => ({ ...base, zIndex: 9999 })
                // }}
                menuPortalTarget={document.body}
                options={endOption}
                isDisabled={readOnly}
                styles={
                  errors?.endType
                    ? {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({ ...base, width: 50 }),
                        ...reactSelectErrorStyles
                      }
                    : {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({ ...base, width: 50 })
                      }
                }
              />
              {data.endType !== SCHEDULE_ENDTYPE.NEVER && (
                <>
                  <div className="fx ml-10">
                    {data.endType === SCHEDULE_ENDTYPE.AFTERNRUNS && (
                      <>
                        <div className="fx mlr10 actr">
                          <SVGIcon name="Reboot" />
                        </div>
                        <div className="numberInput">
                          <TextField
                            customClassName="w50 text-input"
                            type="number"
                            min={1}
                            onBlur={(e) =>
                              Number(e.target.value) < 1 &&
                              handleDurationChange('repeatCount', '1')
                            }
                            disabled={readOnly}
                            placeholder={
                              '1' ||
                              getTranslatedText(
                                intl,
                                'schedule.interval.placeholder'
                              )
                            }
                            onChange={(value) =>
                              handleDurationChange('repeatCount', value)
                            }
                            value={data.repeatCount?.toString()}
                          />
                        </div>
                        <Suffix width="50px">
                          <FormattedMessage id="admin.policyManagement.patch.reboot.loggedInUser.placeholder" />
                        </Suffix>
                      </>
                    )}
                    {data.endType === SCHEDULE_ENDTYPE.AFTERDATETIME && (
                      <>
                        <div className="fx mlr-10 actr">
                          <SVGIcon name="Reboot" />
                        </div>
                        <DatePicker
                          selected={
                            allowTime
                              ? data.endDateAndTime &&
                                dayjs(data?.endDateAndTime).toDate()
                              : data.endDate && dayjs(data.endDate).toDate()
                          }
                          onChange={(value) => {
                            return allowTime
                              ? handleDurationChange('endDateAndTime', value)
                              : handleDurationChange('endDate', value);
                          }}
                          onKeyDown={(e) => e.preventDefault()}
                          placeholderText={
                            allowTime ? 'YYYY-MM-DD, HH:MM' : 'YYYY-MM-DD'
                          }
                          dateFormat={
                            allowTime ? 'yyyy-MM-dd, h:mm aa' : 'yyyy-MM-dd'
                          }
                          {...disablePastProps}
                          required
                          disabled={readOnly}
                          showTimeSelect={allowTime}
                          timeIntervals={15}
                          popperPlacement="auto"
                        />
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
      {errors?.startDateAndTime &&
        reactSelectInlineError(
          // getTranslatedText(intl, 'reports.share.validation.subject')
          getTranslatedText(
            intl,
            errors?.startDateAndTime[0] || 'schedule.settings.error.startDate'
          )
        )}
      {errors?.startDate &&
        reactSelectInlineError(
          getTranslatedText(intl, 'schedule.settings.error.startDate')
        )}
      {errors?.endDateAndTime &&
        reactSelectInlineError(
          getTranslatedText(intl, 'schedule.settings.error.endDateTime')
        )}
      {errors?.repeatCount &&
        reactSelectInlineError(
          getTranslatedText(intl, 'schedule.settings.error.repeatCount')
        )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  &.schedule-disabled {
    opacity: 60%;
  }
  .numberInput {
    .Superops-TextField__Input {
      max-width: 50px;
      min-width: 50px;
      text-align: center;
    }
  }

  .value_selector__control {
    width: 150px;
  }
  .w100p {
    .value_selector__control {
      width: 100px;
    }
  }
  .unit-selector {
    .value_selector__control {
      background: #c4c4c433;
      border: 1px solid #c4c4c433 !important;
      border-radius: 10px 10px 0 0 !important;
    }
  }
  .w50 {
    width: 50px;
  }
  .w120 {
    width: 120px;
  }
  .occurance-input {
    height: 38px;
    margin-bottom: 0px !important;
  }
  .text-input {
    height: 38px;
    margin-bottom: 0px !important;
    .Polaris-TextField__Input {
      text-align: center;
    }
  }
  .datepicker-wrapper {
    input {
      outline: none;
    }
  }
  .Superops-TextField__Input:hover + .Superops-TextField__ActionableSuffix,
  .Superops-TextField__ActionableSuffix {
    border: none;
    padding: 0;
    .value_selector__control {
      bottom: 4px;
    }
  }
  .Superops-TextField__Input:disabled {
    background: transparent !important;
  }
  .Superops-Labelled__Error {
    position: absolute;
  }
`;

const ScheduleMessageContainer = styled.div`
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
`;

export default injectIntl(NewScheduleDurationSection);
